import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui';
import { PageControlsSection, PageMainContainer, PageShadow, PageShadowWrapper, PageStyled, PageSubtitle } from '../../styledComponents';
import { ButtonType } from '../ui/Button';

interface IProps {
	buttons?: IButton[];
	children: ReactElement;
	title?: string | ReactElement;
	subTitle?: string;
	shadow: boolean;
	onBack?: () => void;
	backDisabled?: boolean;
}

export interface IButton {
	label: string;
	onClick: () => void;
	buttonType?: ButtonType;
	disabled?: boolean;
}

function Page(props: IProps) {
	const { buttons, children, title, subTitle, shadow, onBack,  backDisabled } = props;

	const { t } = useTranslation();

	return (
		<PageStyled buttonCount={buttons?.length}>
			{onBack && <Button onClick={onBack} label={t('back')} buttonType="back" disabled={backDisabled}/>}
			{title && <h3>{title}</h3>}
			{subTitle && <PageSubtitle>{subTitle}</PageSubtitle>}
			<PageMainContainer>{children}</PageMainContainer>
			<PageControlsSection notEmpty={(buttons?.length ?? 0) > 0}>
				<PageShadowWrapper>
					{shadow && <PageShadow />}
					{buttons?.map((b, index) => (
						<Button key={index} onClick={b.onClick} label={b.label} buttonType={b.buttonType} disabled={b.disabled} />
					))}
				</PageShadowWrapper>
			</PageControlsSection>
		</PageStyled>
	);
}

export default Page;
